import { LANGUAGES_PATH } from '../constants/translationConfig';
import { translationClient } from './translationClient';

/**
 * GET /translation/v1/languages
 * Response: [ { code: 'ar', name: 'Arabic', native_name: 'العربية', direction: 'rtl' }, ... ]
 * English is not included (it is the source language).
 *
 * @returns {Promise<Array<{code: string, name: string, native_name: string, direction: string}>>}
 *          the raw list; utils/languageList.js turns it into the shape the app uses
 */
export const fetchSupportedLanguages = async () => {
    const response = await translationClient.get(LANGUAGES_PATH);
    if (!Array.isArray(response.data)) {
        throw new Error('Unexpected languages response.');
    }
    return response.data;
};
